export default __webpack_public_path__ + "static/media/pofsis_mark_footer.ea141c83.png";